if ( typeof window.renderHelperCart !== 'function' ) {
	window.renderHelperCart = (text) => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

		const cartItems = document.getElementById('AjaxCartForm');
		cartItems.innerHTML = cartFormInnerHTML;
		cartItems.ajaxifyCartItems();

		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
		});
		document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
		});

		document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

		return sectionInnerHTML;

	};
}

if ( window.KROWN && KROWN.functions && typeof KROWN.functions.dispatchStandardEvent !== 'function' ) {
	KROWN.functions.dispatchStandardEvent = (className, target, detail) => {
		const SE = window.Shopify && window.Shopify.StandardEvents;
		if ( ! SE || typeof SE[className] !== 'function' ) return;
		try {
			( target || document ).dispatchEvent(new SE[className](detail));
		} catch (error) {
			console.warn(`standard-events: ${className}`, error);
		}
	};
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});

						KROWN.functions.dispatchStandardEvent('CartErrorEvent', this, {
							error: alert.textContent
						});
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					window.renderHelperCart(text);

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = this.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

					if ( alert === null ) {
						KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', this, {
							action: newQty === 0 ? 'remove' : 'update',
							context: 'cart',
							lines: [{
								id: item.dataset.id,
								quantity: newQty
							}],
							promise: Promise.resolve({ cart: null })
						});
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}


if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			window.renderHelperCart(text);

			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(() => {
							KROWN.functions.dispatchStandardEvent('CartNoteUpdateEvent', this, {
								context: 'cart',
								note: event.target.value,
								promise: Promise.resolve({ cart: null })
							});
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				const form = this.querySelector('form');
				this.input = this.querySelector('[data-js-discount-input]');
				this.submitButton = button;
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = this.querySelector('[data-js-discount-codes]') || document.querySelector('[data-js-discount-codes]');
				this.pillTemplate = this.querySelector('[data-js-discount-pill-template]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				const onSubmit = (e) => {
					e.preventDefault();
					const inputValue = this.input.value.trim();
					if ( inputValue.length === 0 || this._applying ) return;

					this._applying = true;
					if ( this.submitButton ) this.submitButton.disabled = true;
					this.classList.add(`${this._prefix}processing`);
					if ( this.cartSubtotal ) {
						this.cartSubtotal.classList.add(`${this._prefix}processing`);
					}
					if (this.discountCodes) {
						this.discountCodes.classList.add(`${this._prefix}processing`);
					}

					const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]'))
						.map(elm => elm.dataset.jsDiscount)
						.filter(code => code && code !== '__CODE__');
					const alreadyApplied = existingDiscounts.some(code => code.toLowerCase() === inputValue.toLowerCase());
					const allDiscounts = alreadyApplied ? existingDiscounts : [...existingDiscounts, inputValue];
					const body = JSON.stringify({ discount: allDiscounts.join(',') });

					fetch(`${KROWN.settings.routes.cart_update_url}`, { 
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
						body 
					})
						.then(response => response.json())
						.then(response => {
							const discountCodes = response.discount_codes || [];
							const matchingCode = discountCodes.find(code => 
								code.code && code.code.toLowerCase() === inputValue.toLowerCase()
							);

							if (matchingCode && matchingCode.applicable) {
								this.#handleSuccess(discountCodes);
							} else {
								const applicableCodes = discountCodes
									.filter(entry => entry && entry.applicable && entry.code && entry.code.toLowerCase() !== inputValue.toLowerCase())
									.map(entry => entry.code);
								if (discountCodes.some(entry => entry && entry.code && entry.code.toLowerCase() === inputValue.toLowerCase())) {
									fetch(`${KROWN.settings.routes.cart_update_url}`, {
										method: 'POST',
										headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
										body: JSON.stringify({ discount: applicableCodes.join(',') })
									}).finally(() => this.#handleError());
								} else {
									this.#handleError();
								}
							}
						})
						.catch(error => {
							this.#handleError();
							console.log(`Error: ${error}`);
						})

				};

				if ( button ) button.addEventListener('click', onSubmit);
				if ( form ) form.addEventListener('submit', onSubmit);

			}

			#handleSuccess(discountCodes){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text);

						this._applying = false;
						if ( this.submitButton ) this.submitButton.disabled = false;
						this.classList.remove(`${this._prefix}processing`);
						if ( this.cartSubtotal ) {
							this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						}
						if ( this.cartDiscountError ) this.cartDiscountError.innerHTML = '';
						if ( this.input ) this.input.value = '';

						if ( this.pillTemplate && Array.isArray(discountCodes) ) {
							this.#renderAppliedCodes(discountCodes);
							this.#loadDiscountButtons();
						} else {
							const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
							if ( this.discountCodes && sectionDiscountCodes ) {
								this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
								this.discountCodes.classList.remove(`${this._prefix}processing`);
								this.#loadDiscountButtons();
							}
						}

						const appliedDiscountCodes = this.discountCodes
							? Array.from(this.discountCodes.querySelectorAll('[data-js-discount]')).map(el => ({ code: el.dataset.jsDiscount }))
							: [];
						KROWN.functions.dispatchStandardEvent('CartDiscountUpdateEvent', this, {
							discountCodes: appliedDiscountCodes,
							promise: Promise.resolve({ cart: null })
						});
					})
					.catch(() => this.#handleError())
			}

			#renderAppliedCodes(discountCodes){
				if ( ! this.discountCodes || ! this.pillTemplate ) return;

				const applicable = discountCodes.filter(entry => entry && entry.applicable !== false && entry.code);
				this.discountCodes.innerHTML = '';
				this.discountCodes.classList.remove(`${this._prefix}processing`);

				applicable.forEach(entry => {
					const fragment = this.pillTemplate.content.cloneNode(true);
					const label = fragment.querySelector('.pill__label');
					const removeButton = fragment.querySelector('[data-js-discount]');
					if ( label ) label.textContent = entry.code;
					if ( removeButton ) {
						removeButton.dataset.jsDiscount = entry.code;
						const ariaLabel = removeButton.getAttribute('aria-label') || '';
						removeButton.setAttribute('aria-label', ariaLabel.split('__CODE__').join(entry.code));
					}
					this.discountCodes.appendChild(fragment);
				});
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							if ( this.cartSubtotal ) {
								this.cartSubtotal.classList.add(`${this._prefix}processing`);
							}
							this.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements)
								.map(el => el.dataset.jsDiscount)
								.filter(code => code && code !== '__CODE__');
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(response => response.json())
								.then(response => {
									this.#handleSuccess(response.discount_codes || []);
								})
								.catch(error => {
									this.#handleError();
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(){
				this._applying = false;
				if ( this.submitButton ) this.submitButton.disabled = false;
				this.classList.remove(`${this._prefix}processing`);
				if ( this.cartSubtotal ) {
					this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				}
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				if ( this.cartDiscountError ) {
					this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
				}
			}

		}	
	)
}